// SiSwati translations for QoC Patient Satisfaction Survey
// Generated from QoC_Survey_SiSwati_Translations.xlsx
// Do not edit manually — regenerate from the Excel file

const SS = {
    'invalid_access_title': 'Kufinyelela Lokungasebenti',
    'go_back': 'Buyela emuva',
    'thank_you_title': 'Ngiyabonga!',
    'fill_another': 'Gcwalisa lolunye luhlolo',
    'draft_restored_title': 'Kubhalwa kabusha',
    'start_fresh': 'Kucala kabusha',
    'completion_label': 'Kucedza',
    'select_facility': 'Khetsa Indzawo Yakho',
    'search_facility': 'Funa indzawo yakho...',
    'patient_details': 'Imininingwane lemayelana nesigulane',
    'gender_label': 'Bulili',
    'gender_male': 'Lendvuna',
    'gender_female': 'Labasikati',
    'gender_other': 'Lokunye',
    'age_label': 'Iminyaka yekuphila',
    'age_placeholder': 'sibonelo: 34',
    'paid_question': 'Utikhokhele yini tintfo letitsite lamuhla?',
    'paid_yes': 'Yebo',
    'paid_no': 'Cha',
    'amount_paid_label': 'Ubhadale malini? (Emalangeni)',
    'amount_paid_placeholder': 'sibonelo: 50',
    'visit_details': 'Imininingwane Yekuvakasha',
    'ward_admitted': 'Kuvunyelwa KwaboFakazi',
    'ward_placeholder': 'sibonelo: Luphiko Lwetekwelashwa',
    'depts_visited': 'Ematiko Lavakashelwe',
    'depts_placeholder': 'sibonelo: I-OPD, Ikhemisi',
    'region_label': 'Sifundza',
    'region_placeholder': 'Kugcwaliswa ngemoto kusuka esakhiweni',
    'arrival_time': 'Sikhatsi sekufika',
    'departure_time': 'Sikhatsi Sekuhamba',
    'comments_attitude': 'Kuphawula (Simo Sengcondvo):',
    'comments_supplies': 'Kuphawula (Kuphakelwa):',
    'comments_facility': 'Comments (Facility):', // TODO: needs professional Siswati translation
    'comments_optional': 'Kuphawula lokungakhetsi...',
    'final_comments_title': 'Ikhona yini lenye imibono nobe tiphakamiso?',
    'final_comments_placeholder': 'Tincumo tenu titawusisita kutsi sitfutfukise...',
    'med_not_received': 'Ngumuphi umutsi longazange uwutfole?',
    'review_answers_btn': '← Hlola timphendvulo tami',
    'submit_anyway': 'Ngenisa nobe kunjalo',
    'submitting': 'Kutfumela...',
    'submit_complete': 'Tfumela Imibono Yami',
    'submit_incomplete': 'Phendvula yonkhe imibuto lekufanele ifakwe',
    'answer_all': 'Sicela uphendvule yonkhe imibuto ngaphambi kwekutfumela.',
    'questions_unanswered': 'imibuto lengakaphendvulwa:',
    'all_rows_required': '* yonkhe imigca ledzingekile',
    'required': 'Lokudzingekako',
    'back_btn': 'Ngemuva',
    'lang_toggle_en': '←  Siswati',
    'lang_toggle_ss': '←  SiSwati',
    'invalid_access_body': 'Lolucwaningo lungafinyeleleka kuphela ngekuhlola lelikhodi le-QR lelisemtsetfweni lelikhonjiswe esikhungweni setemphilo. Ema-link lahlanganisiwe akavunywa kwentela kuvikela bucotfo bemibono.',
    'moh_footer': 'Litiko Letemphilo · Luhlelo Lwekunakekelwa Kwetemphilo e-Eswatini',
    'moh_label': 'Litiko Letemphilo · Eswatini',
    'survey_title': 'Luhlolo Lwekwenetiseka Kwetigulane',
    'nqmp_subtitle': 'Luhlelo Lwavelonkhe Lwekuphatsa Lizinga\nImibono yenu isisita kutsi sitfutfukise tinsita tetemphilo.',
    'select_visit_type': 'Sicela ukhetse luhlobo lwekuvakashelwa kwakho:',
    'inpatient_label': 'Kulaliswa ngekhatsi',
    'inpatient_desc': 'Wangeniswa esibhedlela wahlala khona busuku bonkhe',
    'outpatient_label': 'Kugula ngaphandle',
    'outpatient_desc': 'Uvakashele kudokotela futsi wabuyela ekhaya ngelilanga linye',
    'anonymous_note': 'Tonkhe timphendvulo atikabhalwa futsi tisetjentiselwa kuphela kwenta ncono umsebenti.',
    'too_far_title': 'Awusekho kulendzawo',
    'too_far_body_pre': 'Lolucwaningo lwentelwe kuphela tigulane letikhona ku-',
    'too_far_body_post': '.',
    'too_far_distance': 'Budze bakho:',
    'too_far_must_be': 'Kumele kube ngemamitha lalikhulu kusuka kulendzawo',
    'too_far_tip': 'Uma ngabe usendzaweni, sicela uciniseke kutsi tinsita tekutfola indzawo tiyasebenta bese wetama kuskena lelikhodi le-QR futsi.',
    'location_required_title': 'Kufinyeleleka Kwendzawo Lokudzingekako',
    'location_required_body': 'Lolucwaningo ludzinga kutsi ufinyelele endzaweni kute uciniseke kutsi usesikhungweni setemphilo.\n\nKute ukhone kukwenta: tfola sitfombe sekukhiya kubrowser yakho → Site settings → Location → Allow. Bese uphindze uyibuke le-QR code.',
    'location_not_stored': 'Indzawo yakho isetjentiselwa kuphela kucinisekisa kutsi ukulesikhungo. Aligcinwa futsi alihanjiswa.',
    'already_submitted_title': 'Seyivele Ihanjiswe',
    'already_submitted_body': 'Luhlolo lolwentiwe kulendzawo selutfunyelwe kulolucingo kulomnyaka. Umkhicito ngamunye unganiketa imphendvulo yinye kuphela emnyakeni kulesikhungo ngasinye kute kucinisekiswe kubuyeketwa lokunebulungiswa nalokunembako.',
    'thank_you_body': 'Imphendvulo yakho ifakwe ngemphumelelo.\nKusisita kutsi sitfutfukise tinsita tetemphilo e-Eswatini.',
    'draft_restored_body': 'Intfutfuko yakho yangaphambilini seyilayishiwe. Chubeka lapho bewushiye khona.',
    'review_answers_title': '←  Sicela ubuyekete timphendvulo takho',
    'moh_nqmp': 'LiTiko leTemphilo · Luhlelo lwaVelonkhe lwekuPhatfwa kweKhwalithi',
    'inpatient_survey_title': 'Luhlolo Lwekwenetiseka Kwetigulane Letihlala Ematiko',
    'outpatient_survey_title': 'Luhlolo Lwekwenetiseka Kwetigulane Letivela Ngaphandle',
    'TIMELINESS': 'KUPHATSISWA KWAKHO KWAKHO',
    'ATTITUDE': 'INTSANDVO',
    'FACILITY': 'KULULULEKA',
    'SUPPLIES': 'KUNIKETWA KWABANTFU',
    'PATIENT RIGHTS': 'EMALUNGELO ESIGULANI',
    'OVERALL': 'KONKHE',
    'IP.1': 'Ngemuva kwekwemukelwa, walindza sikhatsi lesingakanani ngaphambi kwekutsi unikwe liwadi kanye nembhedze?',
    'IP.2': 'Ngalesikhatsi ulapha, bekunjani kuhlangana kwakho netisebenti tetemphilo?',
    'IP.3': 'Kunjani kubhalwa kwetindlela letiya etindzaweni tekusebentela?',
    'IP.4': 'Lendzawo ihlobile yini? (Tindlu tangasese, tindlu tekugeza, ilinen, liwadi)',
    'IP.5': 'Uwatfolile yini onkhe emaphilisi lakuniketwe wona?',
    'IP.6': 'Utidlile yini tidlo takho ngesikhatsi?',
    'IP.7': 'Bekunjani kudla?',
    'IP.8': 'Beyihlonishwa yini imphilo yakho yangasese ngalesikhatsi uhlala lapha?',
    'IP.9': 'Dokotela wakho wakuchazela ngesimo sakho kanye neluhlelo lwekwelapha?',
    'IP.10': 'Bewati yini kutsi ungafaka sikhalo ngalokusemtsetfweni?',
    'IP.11': 'Beyimnandzi yini indlela lebeyisetjentiswa esibhedlela?',
    'OP.1': 'Walindza sikhatsi lesidze kangakanani ngaphambi kwekutsi utfole lusito?',
    'OP.2': 'Ungasichaza njani sikhatsi lesisetjentiselwa kulawula umsebenti?',
    'OP.3': 'Lesisebenti setemphilo sasitsatsa njani lesimo?',
    'OP.4': 'Kunjani kubhalwa kwetindlela letiya etindzaweni tekusebentela?',
    'OP.5': 'Lendzawo ihlobile yini?',
    'OP.6': 'Uwatfolile yini onkhe emaphilisi lakuniketwe wona?',
    'OP.7': 'Waphatfwa ngenhlonipho yini?',
    'OP.8': 'Dokotela wakho wakuchazela ngesimo sakho kanye neluhlelo lwekwelapha?',
    'OP.9': 'Uniketwe ticondziso leticacile ngekunakekelwa lokulandzelako?',
    'OP.10': 'Bewunelisekile yini ngemsebenti lowatfola?',
    'Very Satisfied': 'Senetisekile',
    'Satisfied': 'Senelisekile',
    'Unsatisfied': 'Angenetiseki',
    'Very Unsatisfied': 'Angenetiseki Kakhulu',
    'Very Good': 'Kuhle kakhulu',
    'Very good': 'Kuhle kakhulu',
    'Good': 'Kuhle',
    'good': 'lokuhle',
    'Average': 'Silinganiso',
    'Poor': 'Labamphofu',
    'Very Poor': 'Bebaphuyile Kakhulu',
    'Very poor': 'Kuphuya kakhulu',
    'Yes': 'Yebo',
    'No': 'Cha',
    '< 30 Minutes': '< 30 wemaminitsi',
    '30min-1 Hour': '30min-1 Lihora',
    '1 Hour-2 Hours': 'Ema-awa langu-2',
    'More than 2 Hours': 'Ngetulu Kwema-Awa Lamabili',
    'Nurse': 'Umhlengikati',
    'Doctor': 'Dokotela',
    'Caterers': 'Tisebenti tekudla',
    'Laboratory': 'I-Laboratory',
    'Pharmacy': 'Emakhemisi',
    'Screening': 'Kuhlola',
    'HIV': 'HIV',
    'MCH': 'MCH',
    'Other': 'Lokunye',
    'ARVs — 1st line (TLD, TLE)': 'Ema-ARV  ←  Umgca wekucala (TLD, TLE)',
    'OI Prophylaxis (Cotrimoxazole)': 'I-OI Prophylaxis (Cotrimoxazole)',
    'TB treatment': 'Kwelapha i-TB',
    'Antenatal supplements (Iron, Folic Acid)': 'Tintfo tekwengeta tekwengeta (i-Iron, i-Folic Acid)',
    'Family Planning commodities': 'Tinsita tekuhlela umndeni',
    'PMTCT (Nevirapine)': 'PMTCT (Nevirapine)',
    'Antibiotics': 'Ema-antibiotic',
    'Pain medication': 'Imitsi yekulwa nebuhlungu',
    'Chronic medication (Diabetes/Hypertension)': 'Imitsi yekwelapha lengasebenti kahle (sifo sashukela/kufutfumala kwengati)',
    'Other medication': 'Leminye imitsi',
};

export default SS;
